import { BaseModal } from "./BaseModal";
import { AddPlaylistForm } from "../form";
import { ModalTypes } from "./ModalTypes";

type Props = {
  onSuccess: () => void;
  onFailure: () => void;
};

export function AddPlaylistModal({ onSuccess, onFailure }: Props) {
  return (
    <BaseModal
      id={ModalTypes.HeaderModal}
      title="Create playlist"
      description="Create a playlist of assets for your canvases."
    >
      <AddPlaylistForm onSuccess={onSuccess} onFailure={onFailure} />
    </BaseModal>
  );
}
